import React from 'react'
import Header from '../../../../components/Business/Thanks/hotelslabo/Header'
import ThankYouContent from '../../../../components/Business/Thanks/hotelslabo/ThankYouContent'
import Footer from '../../../../components/Business/Thanks/hotelslabo/Footer'

export default function HotelslaboThanks() {
    return (
        <>
            <Header />
            <ThankYouContent />
            <Footer />
        </>
    )
}
